import React from "react";
import { icons } from "../../../Assets/Icons/icons";
import { useNavigate } from "react-router-dom";

const WhyChooseUs = () => {
  const navigate = useNavigate();

  const chooseData = [
    {
      icon: icons.lifeBuoyIcon,
      heading: "Personalized Support",
      text: "Receive tailored assistance from our experienced team to ensure every step fits your specific needs and goals.",
    },
    {
      icon: icons.clockIcon2,
      heading: "Time-Saving Process",
      text: "From quick callbacks to streamlined procedures, we value your time and help you move forward without delays.",
    },
    {
      icon: icons.dimondIcon,
      heading: "Trusted Expertise",
      text: "Work with professionals who bring deep industry knowledge and proven strategies to guide your decisions confidently.",
    },
  ];

  return (
    <section className="bg-[#2a1a05] text-white xl:py-20 py-16  xl:px-20 px-6 mt-6">
      <div className="flex flex-col flex-wrap md:flex-row justify-between items-start md:items-center lg:mb-16 mb-8">
        <div className="md:w-2/3 space-y-2">
          <p className="uppercase xl:text-sm text-xs font-semibold text-secondaryTextColor">
            Why Choose Us
          </p>
          <h2 className="xl:text-5xl sm:text-4xl text-3xl font-semibold leading-tight">
            Experience The Difference <br /> With Our Solutions
          </h2>
        </div>
        <button
          onClick={() => navigate("/contact")}
          className="mt-6 md:mt-0 bg-white text-sm lg:text-base text-black font-medium lg:px-6 px-5 py-3 rounded-md shadow-md transition-all duration-300 hover:bg-[#E4E95B] hover:-translate-y-1"
        >
          Contact Us
        </button>
      </div>

      <div className="grid md:grid-cols-3 gap-12 text-left">
        {chooseData.map(({ icon, heading, text }, index) => (
          <div
            key={index}
            className="flex flex-col items-start lg:space-y-3 space-y-2 group"
          >
            <div className="flex items-center lg:mb-5 mb-3 justify-center p-5 group-hover:bg-[#E4E95B] transition-colors duration-300 rounded-full border border-gray-600">
              <span className="lg:text-6xl sm:text-5xl text-4xl text-white group-hover:text-black transition-colors duration-300">
                {icon}
              </span>
            </div>
            <h3 className="text-2xl font-semibold">{heading}</h3>
            <p className="text-gray-400 font-medium leading-relaxed text-base">
              {text}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
